import { TenantService } from "./tenant";
import api from "..";

export default new TenantService(api);
